/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-21 18:20:16
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-12-17 14:39:29
 */
import {aseEncode,aseDecode} from '@/js/utils'
//同步
const mutations = {
  //设置appName
  SET_APP_NAME(state, payload) {
    state.baseInfo.appName = payload
  },
  //设置companyName
  SET_COMPANY_NAME(state, payload) {
    state.baseInfo.companyName = payload
  },
  //设置机构名称organizationName
  SET_ORGANIZATION_NAME(state, payload) {
    state.baseInfo.organizationName = payload
  },
  //设置机构名称organizationName
  SET_ORGANIZATION_NICK_NAME(state, payload) {
    state.baseInfo.organizationNickName = payload
  },
  //设置机构logo
  SET_ORGANIZATION_LOGO(state, payload) {
    state.baseInfo.organizationLogo = payload
  },
  //设置机构名称organizationName
  SET_TELEPHONE(state, payload) {
    state.baseInfo.telephone = payload
  },
  
  //tabsView推入tab
  PUSH_TAB(state, payload) {
  	state.viewTabs.push(payload)
  },
  //tabsView删除tab
  DELETE_TAB(state, payload) {
  	state.viewTabs.splice(payload, 1)
  },
  //重置tabsView
  RESET_TAB(state) {
  	state.viewTabs = []
  },
  //主题颜色修改
  CHANGE_THEME_COLOR(state, payload) {
  	state.themeColor = payload
  },
  //收起或展开菜单
  TOGGLE_LEFT_MENU(state) {
    if (state.menuRelated.isCollapse) {
      state.menuRelated.isCollapse = false
      state.menuRelated.leftMenuWid = '220px'
      state.menuRelated.collapseText = '收起菜单'
    } else {
      state.menuRelated.isCollapse = true
      state.menuRelated.leftMenuWid = '54px'
      state.menuRelated.collapseText = '展开菜单'
    }
  },
  //设置内容区表格的高度
  SET_CONTENT_TABLE_HEI(state, contentView) {
    let totalHei = contentView.$el.clientHeight,//内容区总高度
        formHei = contentView.$refs.form ? contentView.$refs.form.$el.clientHeight : 0, //筛选检索表单的高度
        tableCtrlBtnsHei = contentView.$refs.tableCtrlBtns ? contentView.$refs.tableCtrlBtns.$el.clientHeight : 0, //表格自定义列、导出表格数据等操作按钮栏目的高度
        paginationHei = contentView.$refs.pagination ? contentView.$refs.pagination.$el.clientHeight : 0 //表格分页栏目的高度
    formHei = formHei ? formHei : 0 //避免undefined值
    tableCtrlBtnsHei = tableCtrlBtnsHei ? tableCtrlBtnsHei : 0//避免undefined值
    paginationHei = paginationHei ? paginationHei : 0//避免undefined值
    let returnHei = totalHei - formHei - tableCtrlBtnsHei - paginationHei //最终的高度
    state.contentTableHei = !returnHei || isNaN(returnHei) || (returnHei < 500) ? 500 : (returnHei - 10)
  },
  //设置分页组件每页显示条目个数
  SET_PAGE_SIZE(state, payload) {
    state.pageSize = payload
  },
  //设置分页组件每页显示条目个数的最小基数
  SET_PAGE_BASE_SIZE(state, payload) {
    state.pageBaseSize = payload
  },
	//设置角色权限 
	SET_ROLE_PERMISSION(state, payload){
    state.rolePermission = aseEncode(payload,"AneuPlan-gygfuewifhertfeith56u489trf#%$&gvdfvjrty56&");
  },
  // 设置角色ID
	SET_ROLE_ID(state, payload){
    state.roleID = aseEncode(payload,"AneuPlan-8847￥￥%ERF_)((^%4dkfj&45");
  },
  // 设置能访问的bid
	SET_TABLE_ID_ARR(state, payload){
    state.tableIdArr = aseEncode(JSON.stringify(payload),"AneuPlan-8847￥￥%ERF_)((^%4dkfj&45");
    // state.tableIdArr = payload;
  },
  
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js